import { UIHeading2 } from '@cian/ui-kit';
import { IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './FolderHeader.css';
import { ShareFolderActionsContainer } from '../../containers/ShareFolderActionsContainer';
// import { ShareOffersLinksContainer } from '../../containers/ShareOffersLinksContainer';

interface IProps {
  text: string;
  isFolder: boolean;
  shareFolderEnabled: boolean;
  onEditClick(): void;
}

export function FolderHeader({ text, isFolder, onEditClick }: IProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading2>{text}</UIHeading2>
        {isFolder && <IconFileEdit16 data-testid="edit_icon" data-name="EditIcon" onClick={onEditClick} />}
      </div>

      {isFolder && <ShareFolderActionsContainer />}
      {/* TODO: Удалить после теста */}
      {/* {isFolder && !shareFolderEnabled && <ShareOffersLinksContainer />}  */}
    </div>
  );
}
